// create modal for refill order
import React from "react";
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import Select from "react-select";

class DocumentUploadModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
  };

  render() {
    const { show, onHide } = this.props;

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup>
            <ControlLabel>Document</ControlLabel>
            <br></br>
            <input
              style={{ display: "none" }}
              id="selectDocument"
              type="file"
              className="form-control"
              name="document"
              multiple
              onChange={(e) => this.props.handleDocumentFileChange(e)}
            />
            <Button
              onClick={this.props.uploadDocument}
              style={{ color: "#2B3A41" }}
            >
              {" "}
              <i
                className={
                  this.props.choosedDocument.length == 0
                    ? "fa fa-plus"
                    : "fa fa-pencil fa-fw"
                }
              ></i>{" "}
              {this.props.choosedDocument.length == 0
                ? "Choose File"
                : "Change File"}
              {this.props.choosedDocument.length > 0 && (
                <i
                  className="fa fa-check"
                  style={{
                    color: "green",
                    marginLeft: 5,
                    fontSize: "16px",
                  }}
                  aria-hidden="true"
                ></i>
              )}
            </Button>
            <br />
            {this.props.documentError}
            {this.props.choosedDocument.length > 0 && (
              <div style={{ marginTop: 10 }}>
                {/* <strong>Selected Document:</strong>{" "} */}
                {this.props.choosedDocument.map((doc, index) => (
                  <span
                    style={{
                      background: "white",
                      color: "black",
                      padding: "10px",
                      borderRadius: "10px",
                      display: "inline-flex",
                      alignItems: "center",
                      marginRight: "10px",
                      marginBottom: "10px",
                      border: "1px solid #ccc",
                    }}
                    key={index}
                  >
                    <a href={URL.createObjectURL(doc)} target="_blank">
                      {doc.name}
                    </a>
                    <img
                      onClick={() =>
                        this.props.handleRemoveAttachments(doc.name)
                      }
                      style={{
                        padding: "5px",
                        background: "black",
                        cursor: "pointer",
                        width: "20px",
                        alignSelf: "flex-start",
                        color: "white",
                        marginLeft: "15px",
                        borderRadius: "15px",
                      }}
                      src="https://img.icons8.com/ios-glyphs/30/FFFFFF/delete-sign.png"
                      alt="remove"
                    />
                  </span>
                ))}
              </div>
            )}
          </FormGroup>
          <FormGroup>
            <ControlLabel>Document Type</ControlLabel>
            <Select
              className="react-select primary"
              classNamePrefix="react-select"
              placeholder="Document Type"
              name="documentType"
              value={this.props.selectedDocumentType}
              onChange={(value) => this.props.handleDocumentTypeOnChange(value)}
              options={[
                { value: "Invoice", label: "Invoice" },
                { value: "Payment Slip", label: "Payment Slip" },
              ]}
            />

            {this.props.documentTypeError}
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            className="fl_mb_web_1 btn-fill fl_mb_1 w_100 btn btn-danger"
          >
            Close
          </Button>
          <Button
            className="fl_mb_web_1 btn-fill fl_mb_1 w_100 btn btn-success"
            variant="primary"
            onClick={() => this.props.handleAddDocument()}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DocumentUploadModal;
